/*
 * decaffeinate suggestions:
 * DS101: Remove unnecessary use of Array.from
 * DS102: Remove unnecessary code created because of implicit returns
 * DS207: Consider shorter variations of null checks
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/main/docs/suggestions.md
 */
import { UAParser } from 'ua-parser-js';
Buyapowa.EventTracker = class EventTracker {
  trackAction(action, data) {
    data = {
      event: action,
      data: this._dataWithClientInfo(data, action)
    };

    data[$("meta[name='csrf-param']").attr("content")] = $("meta[name='csrf-token']").attr("content");

    return $.ajax({
      url: $("meta[name='tracking_url']").attr("content"),
      type: 'POST',
      dataType: 'json',
      contentType: 'application/json; charset=utf-8',
      data: JSON.stringify(data)
    });
  }

  _dataWithClientInfo(data, action) {
    const userAgentInfo = new UAParser().getResult();

    data['Referrer'] = document.referrer;
    data['Browser'] = userAgentInfo.browser.name;
    data['Browser Version'] = userAgentInfo.browser.version;
    data['Current URL'] = `${window.location.protocol}//${window.location.host}${location.pathname}`;
    data['Device'] = userAgentInfo.device.model;
    data['Operating System'] = userAgentInfo.os.name;
    data['Screen Height'] =  screen.width;
    data['Screen Width'] = screen.height;
    data['Initial Referring Domain'] = this._initialReferringDomain();
    data['Initial Referring'] = this._initialReferrer();

    if (action === "Share") {
      data['Web Share API Available'] = !!navigator.share;
    }

    return data;
  }

  _initialReferrer() {
    if (Buyapowa.BrowserStorage.get("httpReferrer") != null) {
      return Buyapowa.BrowserStorage.get("httpReferrer");
    }

    const queryParams = window.location.search.substring(1).split('&');

    for (var queryParam of Array.from(queryParams)) {
      var key = queryParam.split("=")[0];
      var encodedUri = queryParam.split("=")[1];

      if ((key === 'http_referrer') && (encodedUri != null)) {
        var decodedUri = decodeURIComponent(encodedUri);

        setTimeout(() => {
          return Buyapowa.BrowserStorage.set("httpReferrer", decodedUri);
        }
        , 1000);

        return decodedUri;
      }
    }

    return null;
  }

  _initialReferringDomain() {
    let initialReferringDomain = Buyapowa.BrowserStorage.get("initialReferringDomain");

    if (initialReferringDomain != null) {
      return initialReferringDomain;
    }

    const htmlReferrer = this._initialReferrer();

    if ((htmlReferrer != null) && (htmlReferrer.length > 0)) {
      const parts = /([^:\/]*?):\/\/([^\/]*)/.exec(htmlReferrer);
      if ((parts != null) && (parts.length === 3)) { // matches [full_match, protocol, domain]
        initialReferringDomain = parts[2];
        setTimeout(() => {
          return Buyapowa.BrowserStorage.set("initialReferringDomain", initialReferringDomain);
        }
        , 1000);

        return initialReferringDomain;
      } else {
        return null;
      }
    } else {
      return null;
    }
  }
};

window.eventTracker = new Buyapowa.EventTracker();
